import React, {useState, useEffect, useRef } from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import RichTextEditor from 'react-rte';


// import Select from "react-select";
// import { callPOST, callGET, callPUT } from '../../../Utils/ApiUtil';
import {fileNameShortenForDisplay,parameterizedURLAccessToken} from '../../../Utils/CommonFunctions';
import Icons from "../../../Components/Icons/Icons";
import MailPreview from "./MailPreview";
import {isValidEmail} from '../../../Utils/UserFunctions';

// const RichTextEditor = React.lazy(() => import('react-rte'));

const NewMail = (props) => {

	const uploadMultipleFiles = useRef();
	const [previewModelOpen,setPreviewModelOpen] = useState(false);
	const [textType,setTextType] = useState('markdown');
	const [previewContent,setPreviewContent] = useState('');
	const editorRef = useRef(null);
	const mailInputRef = useRef(null);

	let isReplyToFromDetailWindow = false;
	if(props.isReplyToFromDetailWindow){
		isReplyToFromDetailWindow = props.isReplyToFromDetailWindow;
	}

	const fieldDetail = JSON.parse(props.formData);
	let bodyVal = fieldDetail.mail_body.value;
	let toVal= fieldDetail.mail_to.value;

	let isToUserMetaDataAvailable = false;
	if(props.toUsers) {
		props.toUsers.map((users,index) => {
			if(users.metatable_id) {
				if(users.metatable_id !== '') {
					isToUserMetaDataAvailable = true;
				}
			}
		})
	}

	if(props.composePage === 'main') {
		isToUserMetaDataAvailable = true;
	}

	let getToVal = '';
	getToVal = toVal.map((tomail,index) => {
		return tomail;
	});

	let suggestions = ''
	suggestions = props.suggestions.map((tomail,index) => {
		let disp = tomail.email_field_display_name && tomail.email_field_display_name !== "" ? tomail.email_field_display_name + "(" + tomail.email_address + ")" : tomail.email_address;
		return (
			<li onClick={e => props.handleAddition(tomail)}>{disp})</li>);
	});
	let toUsers = '';
	toUsers = props.toUsers.map((users,index) => {
		let toTagCss = 'tag-wrapper ReactTags__tag';
		if(users.isValid === false){
			toTagCss = 'tag-wrapper ReactTags__tag_primary_bg';
		}
		return(<span className={toTagCss} style={{"opacity": "1", "cursor": "move"}} draggable="false">{users.field_display_name}<a className="ReactTags__remove" onClick={e=>props.handleDelete(index)}>×</a></span>)
	})

	let ccUsers = '';
	ccUsers = props.ccUsers.map((users,index) => {
		let ccTagCss = 'tag-wrapper ReactTags__tag';
		if(users.isValid === false){
			ccTagCss = 'tag-wrapper ReactTags__tag_primary_bg';
		}
		return(<span className={ccTagCss} style={{"opacity": "1", "cursor": "move"}} draggable="false">{users.email_address}<a className="ReactTags__remove" onClick={e=>props.handleDeleteccUSer(index)}>×</a></span>)
	})

	let bccUsers = '';
	bccUsers = props.bccUsers.map((users,index) => {
		let bccTagCss = 'tag-wrapper ReactTags__tag';
		if(users.isValid === false){
			bccTagCss = 'tag-wrapper ReactTags__tag_primary_bg';
		}
		return(<span className={bccTagCss} style={{"opacity": "1", "cursor": "move"}} draggable="false">{users.email_address}<a className="ReactTags__remove" onClick={e=>props.handleDeletebccUser(index)}>×</a></span>)
	})

	let templates = '';
	templates = props.mail_templates.map((item, index) => {
		return (<option value={item.value}>{item.name}</option>);

	})

	let tags = '';
	tags = props.windowTags.map((item, index) => {
		return (<option value={item.tag_id}>{item.tag_name}</option>);

	})

	let fromAdd = '';
	fromAdd = props.emailConfigList.map((item, index) => {
		return (<option confid={item.id} value={item.user_name}>{item.user_name}</option>);

	})


	const [textEditorValue, setTextEditorValue] = useState(RichTextEditor.createEmptyValue());

	useEffect( ()=>{		
			let bodyVal = fieldDetail.mail_body.value;
			//console.log('bodyVal===new mail',bodyVal);
  		setTextEditorValue(RichTextEditor.createValueFromString(bodyVal, 'html')); 
  }, [props.triggerEffect]);


	const onChangeHandler = (value) => {
		if(textType!="html"){
			setTextEditorValue(value);
			props.addDataTemplateBody(value.toString('markdown'));
		}
	}

	const submitHandler = () => {
	}
	
    const onFileChange =()=>{             
      	var inputField = uploadMultipleFiles;
      	inputField.current.click();
    }

    const uploadMultipleFilesHandler = (e) => {
      props.uploadFileAPICall(e.target.files);
    }

    let toolbarConfig = {
		// Optionally specify the groups to display (displayed in the order listed).
		display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
		INLINE_STYLE_BUTTONS: [
		  {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
		  {label: 'Italic', style: 'ITALIC'},
		  {label: 'Underline', style: 'UNDERLINE'}
		],
		BLOCK_TYPE_DROPDOWN: [
		  {label: 'Normal', style: 'unstyled'},
		  {label: 'Heading Large', style: 'header-one'},
		  {label: 'Heading Medium', style: 'header-two'},
		  {label: 'Heading Small', style: 'header-three'}
		],
		BLOCK_TYPE_BUTTONS: [
		  {label: 'UL', style: 'unordered-list-item'},
		  {label: 'OL', style: 'ordered-list-item'}
		]
	};

	const changeTypeHandler = (e) => {
		setTextType(e.target.value);
	}
 	const isHTML = (str) =>{
  var a = document.createElement('div');
  a.innerHTML = str;

  for (var c = a.childNodes, i = c.length; i--; ) {
    if (c[i].nodeType == 1) return true; 
  }

  return false;
}
	const msgPreview = () => {
		
		let bodyContHTML = textEditorValue.toString('html');
		let bodyContPlain = textEditorValue.toString('markdown');
		let updateText = '';
		//let plainStringConvert = bodyContHTML.replace(/<[^>]+>/g, '');		
		if(textType=="markdown"){
			updateText = textEditorValue['_cache'].html;			
		}else{			
			updateText = textEditorValue['_cache'].html.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&');			
		}		
		//console.log(updateText,'updateText===');
			//return false;
		setPreviewContent(updateText);
		//setPreviewContent(textEditorValue.toString(textType=="markdown"?'html':'html'));
		setPreviewModelOpen(!previewModelOpen);
	}

	const textTypeCont = <div className="ButtonGroup__root___3lEAn col-md-2">
							<select name="textType" className="form-control" onChange={changeTypeHandler} value={textType} >
								<option value="html">HTML</option>
								<option value="markdown">PLAIN</option>
							</select>
						</div>

	const previewAction = <button className="btn primary_bg" onClick={msgPreview}>Preview</button>

	const customControls = [() => textTypeCont,() => previewAction];
	// Custom overrides for "code" style.
	const styleMap = {
		CODE: {
	    	backgroundColor: '#f3f3f3',
	    	fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
	    	fontSize: 16,
	    	padding: 2,
	  	},
	};

	const sendMail = () => {
  		let toMailData = props.toUsers;
      if(mailInputRef.current.value !== '') {
      	let isEmailValid = false; 
        if(isValidEmail(mailInputRef.current.value)){
            isEmailValid = true;    
        }
    		const item = {
              email_address: mailInputRef.current.value,
              email_field_display_name: mailInputRef.current.value,
              field_display_name: mailInputRef.current.value,
              index: toMailData.length,
              metatable_id: "",
              isValid:isEmailValid
          }
        toMailData.push(item);    
      }
      // mailInputRef.current.value="";
     
  		let bodyCont = '';
  		if(textType=="markdown"){
				bodyCont = textEditorValue.toString("html");			
			}else{			
				bodyCont = textEditorValue.toString("html").replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&');			
			}
	  props.saveDataHandler(false,bodyCont);
	  props.handleAddition(toMailData);
	}

	const documentV = props.documentValue && props.documentValue.value !== "" ? 1 : 0;
	return (
		<Wrp>
			<div className={props.modelOpen === true ? "custom-template eComOpen open" : "custom-template eComOpen"}>
				
				<div className="card_Box">

					<div className="card_Header">
						<div className=" ">Compose New Email </div>
					</div>

					<div className="card_Body">
						 
							<div className="page-content mail-content  ">
								
								<div className="email-compose-fields">

									<>
									{
										isReplyToFromDetailWindow === false ?
											<>
											<div className="form-group row mb-3">
												<label htmlFor="subject" className="col-form-label col-md-1">Templates :</label>
												<div className="col-md-6">
													<select className="form-control" onChange={e=>props.callTemplateData(e)}>
														<option value="">-- Choose Templates --</option>
														{templates}
													</select>
												</div>
												<label htmlFor="tags" className="col-form-label col-md-1">Tags :</label>
												<div className="col-md-4">									
													<select className="form-control" onChange={e=>props.filterTemplateByTagHandler(e)}>
														<option value="">-- Choose Tags --</option>
														{tags}
													</select>
												</div>
											</div>

											<div className="form-group row mb-3">
												<label htmlFor="to" className="col-form-label col-md-1">From <span className="text-danger">*</span> :</label>
												<div className="col-md-11">
													<select className="form-control" name="mail_from" value={fieldDetail.mail_from.value} onChange={e=>props.addDataHandler(e)}>
														<option value=""></option>
														{fromAdd}
													</select>
													{fieldDetail.mail_from.error !== "" ? 
                          <label className="error m-0">{fieldDetail.mail_from.error}</label>
                          : null
                          }
												</div>
											</div>
											</> 
										: 
										''
									}
									</>
									

									<div className="form-group row">
										<label htmlFor="to" className="col-form-label col-md-1">To <span className="text-danger">*</span> :</label>
										<div className="col-md-11">


											<div className="ReactTags__tags react-tags-wrapper" style={{"paddingRight":"60px"}}>
												<div className="ReactTags__selected">
												{toUsers}										
												<div className="ReactTags__tagInput">
													<input 
													class="ReactTags__tagInputField width_98_per" 
													ref={mailInputRef}
													type="text" 
													placeholder="Add Users List" 
													aria-label="Add Users List"											
													onChange={e=> props.searchUserHander(e)}
													onKeyDown={e => props.handleKeyDown(e)}
													onClick={e=> props.searchUserHander(e)}
													value={props.toInputValue}
													/>
													{props.suggestions.length > 0 ?
													<div className="ReactTags__suggestions"><ul>{suggestions}</ul></div>	
													: 
													''
													}
													
												</div>
												</div>
											</div>

											{ /*<input type="text" className="form-control no-bd pl-0 newMail_custom" id="mail_to" name="mail_to" value={getToVal} onChange={e => props.addDataHandler(e)} />*/ }
											<a onClick={props.ccToggleHandler} className="icon-right third_light_color mr-3 cursor_pointer" style={{"right":"5px"}}>Cc </a>
											<a onClick={props.bccToggleHandler} className="icon-right third_light_color mr-5 cursor_pointer" style={{"right":"5px"}}>Bcc </a>
											{fieldDetail.mail_to.error !== "" ? 
				                            <label className="error m-0">{fieldDetail.mail_to.error}</label>
				                            : null
				                            }
										</div>
									</div>
									{
										props.ccShow === true ?
											<div className="" id="eCC">
												<div className="form-group row mb-3" id="eCC">
													<label htmlFor="cc" className="col-form-label col-md-1">Cc :</label>
													<div className="col-md-11">

														<div className="ReactTags__tags react-tags-wrapper">
															<div className="ReactTags__selected">
															{ccUsers}										
															<div className="ReactTags__tagInput">
																<input 
																class="ReactTags__tagInputField" 
																type="text" 
																placeholder="Add CC List" 
																aria-label="Add CC List"																									
																onChange={e => props.ccSearchUserHander(e)} 
																onKeyDown={e => props.ccHandleKeyDown(e)}
																value={props.ccInputValue}
																/>														
															</div>
															</div>
														</div>

														
													</div>
												</div>
											</div>
										: null
									}

									{
										props.bccShow === true ?
											<div className="" id="eCC">
												<div className="form-group row mb-3" id="eCC">
													<label htmlFor="cc" className="col-form-label col-md-1">Bcc :</label>
													<div className="col-md-11">

														<div className="ReactTags__tags react-tags-wrapper">
															<div className="ReactTags__selected">
															{bccUsers}										
															<div className="ReactTags__tagInput">
																<input 
																class="ReactTags__tagInputField" 
																type="text" 
																placeholder="Add BCC List" 
																aria-label="Add BCC List"																									
																onChange={e => props.bccSearchUserHander(e)} 
																onKeyDown={e => props.bccHandleKeyDown(e)}
																value={props.bccInputValue}
																/>														
															</div>
															</div>
														</div>

														
													</div>
												</div>
											</div>
										: null
									}
									
									<div className="form-group row mb-3">
										<label htmlFor="subject" className="col-form-label col-md-1">Subject <span className="text-danger">*</span> :</label>
										<div className="col-md-11">
											<input autocomplete="off" type="text" className="form-control no-bd pl-0 newMail_custom" id="mail_subject" name="mail_subject" value={fieldDetail.mail_subject.value} onChange={e => props.addDataHandler(e)} />
											{fieldDetail.mail_subject.error !== "" ? 
				                            <label className="error m-0">{fieldDetail.mail_subject.error}</label>
				                            : null
				                            }
										</div>
									</div>							
								</div>

								{
								// Removed the 'isToUserMetaDataAvailable' condition to make the attachments section always visible. The 'To' email is not required for attachments.
								// isToUserMetaDataAvailable ? 
								<Wrp>
								<div className="form-group row mb-0">
									<label htmlFor="subject" className="col-form-label col-md-1">Attachments :</label>
									<div className="col-md-8">
										<div className="btn-group">
							          		<a onClick={onFileChange} data-tip="Upload Image" className="btn btn-border border-default"> 					            	
							            		<Icons iconType="Attachments" />
							          		</a>
							          		<a onClick={e => props.tableModalHandler('PDF')} className="btn btn-border btn-default" data-toggle="tooltip" data-placement="top" data-title="Attach PDF from templates" data-trigger="hover" data-original-title="" title=""><Icons iconType="PDF" /></a>
							          		<a onClick={e => props.tableModalHandler('CSV')} className="btn btn-border btn-default" data-toggle="tooltip" data-placement="top" data-title="Attach CSV from templates" data-trigger="hover" data-original-title="" title=""><Icons iconType="CSV" /></a>
							          		<a onClick={e => props.tableModalHandler('DOCUMENT')} className="btn btn-border btn-default" data-toggle="tooltip" data-placement="top" data-title="Attach Document" data-trigger="hover" data-original-title="" title=""><Icons iconType="Contacts" /></a>
											
										</div>
										<input id="fileInput" accept="*" ref={uploadMultipleFiles} type="file" multiple style={{display:'none'}}  onChange={uploadMultipleFilesHandler}  />						          	
						          	</div>
						          	
								</div>

								<div className="email-attachments d-flex justify-content-between">
									<div className="form-group ">
										<label className="col-form-label border-bottom mb-0"> Local Attachments <span>({props.files.length} files)</span> </label>
										<ul>
											{
												props.files.map((itemFile,index)=>{
													let imagePath = '/assets/img/noimage.png';
		                    	if(itemFile.id!==''){
		                      	imagePath = parameterizedURLAccessToken('files/download?fileId='+itemFile.id)
		                    	}
		                    	const itemFileLabel = fileNameShortenForDisplay(itemFile.label);
		                    	const itemSize = itemFile.size;
		                    	return(
		                    		<li key={index+'wrp'}>																			                      		
		                    			<a href="#">{itemFileLabel} <span>({itemSize} KB)</span></a>
		                    			<span>&nbsp;</span>
		                    			<small onClick={e=>props.removeAddedFile(index)}><i className="far fa-trash-alt fa-lg cursor-pointer"></i></small>								                        								                      							                      
		                    		</li>
		                    	)	
												})
											}
											
										</ul>
									</div>

									<div className="form-group ">
										<label className="col-form-label border-bottom mb-0"> Files & Document Attachments <span>({props.filesInternal.length + documentV} files)</span> </label>
										<ul>
											{
												props.filesInternal.map((itemFile,index)=>{
													let imagePath = '/assets/img/noimage.png';
		                    	if(itemFile.id!==''){
		                      	imagePath = parameterizedURLAccessToken('files/download?fileId='+itemFile.id)
		                    	}
		                    	const itemFileLabel = fileNameShortenForDisplay(itemFile.label);
		                    	const itemSize = itemFile.size;
		                    	return(
		                    		<li key={index+'wrp'}>																			                      		
		                    			<a href="#">{itemFileLabel} <span>({itemSize} KB)</span></a>
		                    			<span>&nbsp;</span>
		                    			<small onClick={e=>props.removeAddedFileInternal(index)}><i className="far fa-trash-alt fa-lg cursor-pointer"></i></small>								                        								                      							                      
		                    		</li>
		                    	)	
												})
											}
											{
												props.documentValue && props.documentValue.value !== "" ?
													<li>																			                      		
                    				<a href="#">{props.documentValue.name}</a>
                    				<span>&nbsp;</span>
                    				<small onClick={e=>props.removeAddedFileDocument()}><i className="far fa-trash-alt fa-lg cursor-pointer"></i></small>
		                    	</li>
												: null
											}
										</ul>
									</div>
								</div>
								</Wrp>
								// : null
								}

								<div className="email-editor">
									<RichTextEditor
								        value={textEditorValue}
								        onChange={onChangeHandler}
								        toolbarConfig={toolbarConfig}
								        placeholder="Click here to reply"
								        editorClassName="texteditor_height"
								        toolbarClassName = "ddddddddddddd"
								        customStyleMap={styleMap}
								        className="dfasdfsdfasfasdfadsf"
								        showToolbar={false}
								        ref={editorRef}
								         {...{ customControls } }
								      />
								</div>
							</div>
						 
					</div>

					<div className="card_Footer justify-content-between"> 
						 
							<div> <a onClick={props.clickHandler} className="btn border-default btn-border">Cancel</a> </div>
							<div className="btn-group">
								{props.composePage === 'main'? 
								<a onClick={props.saveDraftHandler} className="btn primary_bg"> Save as Draft </a> : ''}								
								<a onClick={sendMail} className="btn primary_bg"> Send </a>
							</div>
						 
					</div>

				</div>
				
				

				<div className="custom-toggle4" onClick={props.clickHandler}>
					<i className="fas fa-times"></i>
				</div>
			</div>
			{
				props.modelOpen === true ?
					<div className="sidebar-overlay-email"></div>
				: null
			}

			<MailPreview 
				isModelOpen={previewModelOpen} 
				msgPreview={msgPreview} 
				content={previewContent}
			/>
		</Wrp>
	)
}

export default NewMail;